/* eslint-disable */
import $ from 'jquery';
import * as TWTmediaQuery from './twt.media-query';

// scroll page to container top
function scrollNavCategories(container) {
  // scroll to element position
  $('html, body').animate({
    scrollTop: $(container).offset().top
  }, 400);
}

// collapse container
function collapseContainer(target) {
  var $this = $(target);
  var objData = $this.data();
  var $elPreviousContainer = $this.prev();

  if (!objData.hasOwnProperty('state') || objData.state === 'opened') {
    $elPreviousContainer.animate({'height': objData.intMinHeight,}, 400);
    $this.find('.btn__text').text(objData.buttonTextClose);
    $this.data('state', 'closed');
  } else {
    $elPreviousContainer.animate({'height': objData.intMaxHeight}, 400);
    $this.find('.btn__text').text(objData.buttonTextOpen);
    $this.data('state', 'opened');
  }

  $this.addClass('js-collapse');

  $this.toggleClass('less');
}

export default function manageSearchResultCategories() {
  var $elNavCategories = $('.nav--categories');   // sidebar nav

  // set category filter in filter form
  $elNavCategories.find('[data-store]').on('click', function(){ // individual categories
    var $this = $(this);
    var mixedValue = $this.data('value');
    var strStore = $this.data('store');
    $(`input[data-receive="${strStore}"]`).val(mixedValue).trigger('update');
  });

  // submit from after category was updated
  $('[data-receive]').on('update', () => {
    $(this).closest('form').submit();
  });

  $elNavCategories.find('[data-collapse]').each((index, button) => {
    collapseContainer(button);
  });

  // collapse on click (weniger anzeigen button)
  $elNavCategories.find('[data-collapse]').on('click', (event) => {
    collapseContainer(event.currentTarget);
  });

  // after class js collpase was set on click scroll to container top
  $elNavCategories.find('.js-collapse').on('click', function(event) {
    var $this = $(this);
    var objData = $this.data();
    var $elPreviousContainer = $this.prev();

    if ($this.data().state !== 'opened') {
      scrollNavCategories($elPreviousContainer);
    }
  });

  //
  $(window).on('resize', function(){
    // set CSS
    $elNavCategories.css('transition', 'none');

    // weniger anzeigen buttons
    $elNavCategories.find('[data-collapse]').each(function(){
      var $this = $(this);
      var objData = $this.data();
      var $elPreviousContainer = $this.prev();
      var $elItems = $elPreviousContainer.children();
      var $elLastVisibleItem = $elItems.eq(objData.itemsLimit).prev();
      var intMinHeight = $elLastVisibleItem.position().top + $elLastVisibleItem.outerHeight(true);
      var intMaxHeight = $elPreviousContainer.css('height', 'auto').height();

      $this.data('intMinHeight', intMinHeight);
      $this.data('intMaxHeight', intMaxHeight);

      if (objData.hasOwnProperty('state') && objData.state === 'closed') $elPreviousContainer.css('height', intMinHeight);
    });

    // remove styles
    setTimeout(function(){
      $elNavCategories.removeAttr('style');
    });
  }).trigger('resize');

  // mobile nav
  $('[data-toggle="nav--categories"]').on('click', function() {
    const currentSize = TWTmediaQuery.getCurrentSize();
    if ((currentSize === ('xs' || 's' || 'm'))) {
      var $this = $(this);
      var objData = $elNavCategories.data();

      if (objData.hasOwnProperty('scrollTop')) {
        var intScrollTop = objData.scrollTop;
        document.body.scrollTop = intScrollTop;
        document.documentElement.scrollTop = intScrollTop;
        $elNavCategories.removeData('scrollTop');
      } else {
        $elNavCategories.data('scrollTop', (document.body.scrollTop || document.documentElement.scrollTop));
      }

      $('body').toggleClass('has--open-categories');
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/searchresult-categories.js